import React, { useState } from 'react';
import DocsGridItems from './DocsGridItems';
import DocsSubGrid from './DocsSubGrid';

function DocsGrid({ item, index, patientId, handleReload }) {
  const [toggleGrid, setToggleGrid] = useState(false);
  const handleToggleGrid = () => {
    setToggleGrid(!toggleGrid);
  };
  return (
    <div
      className={
        toggleGrid
          ? 'chld-doc-active-rw docMaingrid-Pat-sb-bdy grid-sec'
          : `docMaingrid-Pat-sb-bdy grid-sec ${index % 2 === 0 ? 'alt-rw' : ''}`
      }
    >
      <DocsGridItems
        item={item}
        handleToggleGrid={handleToggleGrid}
        toggleGrid={toggleGrid}
        patientId={patientId}
        handleReload={handleReload}
      />
      {item?.childDocumentDetailArr.length > 1 && (
        <DocsSubGrid
          toggleGrid={toggleGrid}
          subGridItems={item?.childDocumentDetailArr}
          patientId={patientId}
          handleReload={handleReload}
        />
      )}
    </div>
  );
}

export default DocsGrid;
